.root {
  font-size: var(--font-size-helptext);
  font-weight: var(--font-weight-light);
  color: var(--field-color);
}

.error {
  color: var(--field-border-color-error);
}
